import { observable, computed, makeObservable } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

// ActivityStore：兼容 list 组件用法，提供统一的列表数据、状态、属性获取接口
export class LotteryStore {
    @observable namespace = 'lottery';

    @observable lotteryActivitiesTicketsList = null;
    @observable lotteryActivitiesInvitationsList = null;
    @observable lotteryActivitiesRecordsList = null;
    @observable lotteryActivitiesSurprisesList = null;
    
    @observable lotteryData = null; // 抽奖详情数据

    constructor(initData = {}) {
        this.listStore = new ListStore();
        // 注册业务list
        this.listStore.registerList({ namespace: 'lotteryActivitiesTicketsList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.lotteryActivitiesTicketsList) {
            this.listStore.lists['lotteryActivitiesTicketsList'].data = initData.lotteryActivitiesTicketsList;
        }
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get lotteryActivitiesTicketsList() {
        return this.listStore.getList({ namespace: 'lotteryActivitiesTicketsList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get lotteryActivitiesTicketsListAttribs() {
        return this.listStore.lists['lotteryActivitiesTicketsList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get lotteryActivitiesTicketsListLoading() {
        return this.listStore.lists['lotteryActivitiesTicketsList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get lotteryActivitiesTicketsListError() {
        return this.listStore.lists['lotteryActivitiesTicketsList']?.requestError || { isError: false, errorText: '' };
    }
}

// 不再导出 Store 实例，全部用 Action 实例